import { StatusEnum } from "@project-management-system/shared-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('skechers_orders')
export class SkechersOrdersEntity {
    @PrimaryGeneratedColumn('increment', {
        name: "id",
    })
    id: number;

    @Column("varchar", {
        name: "po_number",
    })
    poNumber: string

    @Column("varchar", {
        name: "po_style",
    })
    poStyle: string

    @Column("text", {
        name: "delivery_address",
    })
    deliveryAddress: string

    @Column("varchar", {
        name: "line_no",
    })
    lineNo: string


    @Column("varchar", {
        name: "ex_factory_date",
    })
    exFactoryDate: string

    @Column('varchar', {
        name: "delivery_date"
    })
    deliveryDate: string

    @Column("varchar", {
        name: "item_type",
    })
    itemType: string


    @Column("varchar", {
        name: "color",
    })
    color: string

    @Column("varchar", {
        name: "size",
    })
    size: string

    @Column("varchar", {
        name: "quantity",
    })
    quantity: string

    @Column({
        type: 'enum',
        enum: StatusEnum,
        name: 'status',
    })
    status: StatusEnum;

    @CreateDateColumn({
        name: "created_at",
    })
    createdAt: string;

    @Column("varchar", {
        nullable: true,
        name: "created_user",
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
    })
    updatedAt: string;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag",
    })
    versionFlag: number;

    @Column({
        nullable: false,
        name: "is_active",
        default: 1
    })
    isActive: boolean;


}